module.exports = __webpack_public_path__ + "static_assets/fonts/rsooicons.8a4c379.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/rsooicons.ttf
// module id = ix5Z
// module chunks = 40